import { useTranslation } from 'react-i18next'
import isEmpty from 'lodash-es/isEmpty'

import { parseServerValidation } from '../../../../../utils/validation'
import { EntityProfileHeaderEditTitleModal } from '../../../../Entity'
import { useDocFlowContext } from '../../../DocFlow.hooks'
import { DocFlowProfileHeaderEditTitleField } from '../../../DocFlowProfileHeaderEditTitleField'

import {
  getDocFlowProfileHeaderEditTitleInitialValue,
  getDocFlowProfileHeaderEditTitlePayload,
  getDocFlowProfileHeadertEditTitleValidationSchema,
} from './useDocFlowProfileHeaderEditTitle.utils'

export function useDocFlowProfileHeaderEditTitle() {
  const { t } = useTranslation()

  const { docFlow, handleCloseModal, handleUpdateDocFlow, setModal } =
    useDocFlowContext()

  function handleEditTitle({ setErrors, setSubmitting, value }) {
    handleUpdateDocFlow(value)
      .then(handleCloseModal)
      .catch(({ response }) => {
        if (!isEmpty(response?.data)) {
          setSubmitting(false)
          setErrors(parseServerValidation(response?.data))
        }
      })
  }

  function handleOpenEditTitleModal() {
    setModal(
      <EntityProfileHeaderEditTitleModal
        Fields={DocFlowProfileHeaderEditTitleField}
        formBodyProps={{ withNotifications: true }}
        getPayload={getDocFlowProfileHeaderEditTitlePayload}
        initialValues={getDocFlowProfileHeaderEditTitleInitialValue(
          docFlow?.name
        )}
        validationSchema={getDocFlowProfileHeadertEditTitleValidationSchema(t)}
        onClose={handleCloseModal}
        onSubmit={handleEditTitle}
      />
    )
  }

  return {
    handleEditTitle,
    handleOpenEditTitleModal,
  }
}
